import React from "react";
import TrapezeHeader from "Components/TrapezeHeader";
import { FaQuestion } from "react-icons/fa";
import { ButtonBrand } from "Components/Button";
import { connect, useSelector } from "react-redux";
import { getWidth } from "redux-window";
import { generalInteraction } from "../../modules/analytics";
import { userAgencyObject, userCompanyObject } from "../../modules/auth";

const FindDestinationOrVenueCompany = ({
  headerText = "Can’t find a destination or venue?",
  userCompany,
  mainMessage = <span></span>,
  linkToURL = "mailto:data@edgevenues.com?subject=Company User requesting new venue&body=Company Name: " + userCompany.name + ".%0D%0AYour EDGE Team will research and load your preferred destination or venues to a minimum level of data and advise you as soon as its complete in order for you to continue your buying journey.  Please add your requirements here and send this email:",
  buttonText = "Click to add",
  generalInteraction,
}) => {
  const mobile = useSelector(state => getWidth(state) < 768);
  return (
    <div className="bg-white mt-6 flex flex-wrap">
      <div className="w-full md:w-2/5">
        <TrapezeHeader
          bgColor="orange"
          title={headerText}
          bigText={!mobile}
          icon={<FaQuestion className="text-white mr-2" />}
        />
      </div>
      <div className="w-full md:w-3/5 flex items-center justify-between pl-4 md:pl-0 pr-4 mt-2 md:mt-0">
        {mainMessage}
        <ButtonBrand
          outlined
          Element="a"
          href={linkToURL}
          classes="border-3 rounded-sm w-full md:w-auto"
          onClick={() => {
            generalInteraction({ type: "general_upgrade_click" });
          }}
        >
          {buttonText}
        </ButtonBrand>
      </div>
    </div>
  );
};
const mapStateToProps = state => {
  console.log(state.auth)
  return {
    userCompany: state.auth.user.companyObject
  };
};
export default connect(mapStateToProps, { generalInteraction })(FindDestinationOrVenueCompany);
